<template functional>
    <div class="group-header">
        <div
            @click="listeners.toggleCollapse"
            class="group-header__details"
        >
            <i
                class="icon"
                :class="props.isExpanded ? 'icon-chevron_up' : 'icon-chevron_down'"
            />
            <span class="group-header__details-title">
                <span v-if="props.isExpanded">
                    {{ parent.$t('minimize') | capitalize }}
                </span>
                <span v-else>
                    {{ parent.$t('Show All') | capitalize }}
                </span>
            </span>
        </div>
        <div
            @click="listeners.unpinAll"
            class="group-header__details"
        >
            <span class="group-header__details-title mr-1">{{ parent.$t('unpin all') | capitalize }}</span>
            <i class="icon icon--md icon-pin_45_left"/>
        </div>
    </div>
</template>

<script>
    export default {
        functional: true,
        name: 'PinnedSectionHeaderRow',
        props: {
            isExpanded: {
                type: Boolean,
                required: true
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/eventGrid/components/PinnedSectionHeaderRow.vue